import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Events, NavController } from 'ionic-angular';
import { EditViewPageComponent } from '../edit-view/edit-view.component';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';

const readViewMap = {
  "AWARDS": "awards",
  "EDUCATION": "education",
  "MEMBERSHIPS": "memberships",
  "EXPERIENCE LEVEL": "careerHistory",
  "CERTIFICATIONS": 'certifications',
  "LANGUAGES": "languages",
  "TRAVELPREFERENCES": "locationPreference",
  "SKILLS": 'skills',
  "OBJECTIVE": 'objective',
  "ATTACHMENTS": 'attachments'
}

const TimelineItems = [
  'WORKEXPERIENCE',
  'PROJECTEXPERIENCE',
  'EDUCATION',
  'CERTIFICATIONS',
  'SKILLS',
  'LANGUAGES',
  'MEMBERSHIPS',
  'AWARDS'
];

@Component({
  selector: 'page-read-view',
  templateUrl: 'read-view.component.html'
})
export class ReadViewPageComponent implements OnInit {
  @Input() key: any;
  @Output() filterItem: EventEmitter<any> = new EventEmitter();
  public data: any;
  public configData: any;
  public attachmentEditOn = false;
  public resumeAction: any;   
  
  constructor(
    public events: Events,
    public resumeService: ResumeService,
    public navCtrl: NavController
  ) {
    this.events.subscribe('refreshEditResumeData', (data) => {
      this.ngOnInit();
    });
    this.resumeAction = this.resumeService.getResumeAction();
  }

  ngOnInit() {
    this.getDataAndConfig();
  }

  editSection() {
    // objective is not an array its an object
    if (this.data == null && this.configData.name != 'OBJECTIVE' && this.configData.name != 'TRAVELPREFERENCES' && this.configData.name != 'EXPERIENCE LEVEL') {
      this.data = [];
    }
    if (this.configData.name == 'TRAVELPREFERENCES') {
      if (this.data == null) {
        this.data = {};
      }
    } else if (this.configData.name == 'EXPERIENCE LEVEL') {
      if (this.data == null) {
        this.data = {};
      }
      this.fillConfigValue();
    } else if (this.configData.name == 'ATTACHMENTS') {
      this.attachmentEditOn = true;
      this.fillAttachmentsConfig();
    } else if (this.configData.name == 'OBJECTIVE') {
      if (this.data == null) {
        this.data = {};
      }
      this.data['fieldDisplayType'] = 'OBJECTIVE';
    }
    if (TimelineItems.indexOf(this.configData.name) >= 0) {
      this.events.publish('filterResumeTimeLine', this.configData);
      return;
    }
    this.navCtrl.push(EditViewPageComponent, {
      config: this.configData,
      data: this.configData.name == 'ATTACHMENTS' ? { attachments: this.data } : this.data
    });
  }

  getYear(date) {
    if (date == null) {
      return null;
    }
    const d = new Date(date);
    return d.getFullYear();
  }

  getMaxStars(){
    return this.resumeService.getMaxStars(this.configData);
  }

  getLangValue(lang) {
    var profecs = [];
    if (lang["readingCode"] >= 0) {
      profecs.push(this.configData.modelFields.filter(a => a.fieldName == 'ReadingCode')[0]['fieldTitle']);
    }
    if (lang["writingCode"] >= 0) {
      profecs.push(this.configData.modelFields.filter(a => a.fieldName == 'WritingCode')[0]['fieldTitle']);
    }
    if (lang["conversationCode"] >= 0) {
      profecs.push(this.configData.modelFields.filter(a => a.fieldName == 'ConversationCode')[0]['fieldTitle']);
    }
    return profecs.join('/');
  }

  private getVideoPath() {
    if (this.data.attachments && this.data.attachments.length > 0) {
      const attach = this.data.attachments[0];
      if (attach) {
        attach.videoURL = window.localStorage.getItem(Storage.DATASTORE) + 'FileAssets/' + attach.identifier;
      }
    }
  }

  private fillAttachmentsConfig() {
    this.configData.modelFields = [{
      "fieldGroup": "ResumeAttachments",
      "fieldName": "AttachmentRequired",
      "fieldTitle": "Attachment",
      "fieldDataTypeName": "bit",
      "displayTypeName": "checkbox",
      "options": null,
      "attributes": [],
    }];
  }

  private fillConfigValue() {
    this.configData.modelFields = [
      {
        "fieldGroup": "ExperienceObjective",
        "fieldName": "experienceYears",
        "fieldTitle": "Years",
        "fieldDefaultValue": "0",
        "displayTypeName": "number",
        "baseline": true,
        "options": null,
        "attributes": [],
      },
      {
        "fieldGroup": "PositionsObjective",
        "fieldName": "positions",
        "baseline": true,
        "fieldTitle": "Positions",
        "fieldDefaultValue": "0",
        "displayTypeName": "number",
        "options": null,
        "attributes": [],
      },
      {
        "fieldGroup": "LevelObjective",
        "fieldName": "careerLevelCode",
        "fieldTitle": "Current Career Level",
        "fieldDefaultValue": "",
        "baseline": true,
        "displayTypeName": "libraries",
        "options": null,
        "attributes": [],
      }
    ];
  }

  private getDataAndConfig() {
    this.data = this.resumeService.getResumeValue(readViewMap[this.key]);
    this.configData = this.resumeService.getConfigValue(this.key);
    if (this.configData.name == 'OBJECTIVE' && this.data) {
      this.getVideoPath();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/resume/read-view/read-view.component.ts